<template>
    <div>
        <h1 class="display-heading">Family Members</h1>

        <div class="d-flex align-items-baseline">
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Full Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter full name" data-vv-validate-on="blur"
                    v-model="filterName"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Identity Type:</label>
                <select name="filterIdentityType" data-vv-validate-on="blur" data-vv-as="identification type"
                    v-validate="identificationTypeValidation" v-model="filterIdentityType" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('filterIdentityType')
                }">
                    <option value="0">Please Select</option>
                    <option v-for="(identificationType, index) in identificationTypes" :key="index"
                        :value="identificationType.text">
                        {{identificationType.text}}
                    </option>
                </select>
                <div v-show="validationErrors.has('filterIdentityType')" class="invalid-feedback">
                    {{ validationErrors.first('filterIdentityType') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Identity Number:</label>
                <input style="width: 150px" type="text" name="filterIdentityNumber" data-vv-as="filter NRIC" data-vv-validate-on="blur"
                    v-mask="filterIdentityType === 1 ? '######-##-####' : null" v-model="filterIdentityNumber"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterIdentityNumber')
                    }">
                <div v-show="validationErrors.has('filterIdentityNumber')" class="invalid-feedback">
                    {{ validationErrors.first('filterIdentityNumber') }}
                </div>
            </div>
            <button @click="getfamily" class="btn btn-primary">Search</button>
            <i class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" data-placement='right' :title="getSearchLabel()"></i>
        </div>

        <div class="card mb-3">
            <div class="card-header">Add Family Member</div>
            <div class="card-body">
                <!-- <router-link :to="{
                    'name': 'family-detail-add',
                }" class="btn btn-primary btn-primary-insv mr-2">
                    Add dependent
                </router-link> -->

                <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="addDependent()">
                    Add dependent
                </button>
            </div>
        </div>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col>
                    <col width="200">
                    <col width="150">
                    <col width="150">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Full Name</th>
                            <th scope="col">NRIC</th>
                            <th scope="col">Relationship</th>
                            <th scope="col">Guardian Request Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="familyList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(family, index) in familyList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{family.name}}</td>
                            <td>{{family.nric}}</td>
                            <td>{{family.relationship}}</td>
                            <td>
                                <span :class="'badge badge-pill ' + getGuardianRequestStatusClass(family.allowGuardianRequest, family.guardianRequestStatus)">
                                    {{getGuardianRequestStatus(family.allowGuardianRequest, family.guardianRequestStatus)}}
                                </span>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'family-detail',
                                    'params': {'id': family.userDependentId}
                                }">
                                View family
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <small>*Auto granted - means by default user can view dependents' medical records when they are still aged below 18</small>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
        <popup-modal ref="kycPopup" :hasCloseButton="false" title="Alert">
            <template slot="content">
                <p>We notice that you have submitted a request for managing a family member’s medical records in future.</p>
                <p>Before we can approve such request, there is an extra process you are required to comply, namely eKYC (also known as electronic know your customer).</p>
                <p>This is part of our measures for safeguarding the data security and privacy of our customers.</p>
                <p>eKYC is an one-off process, the images of your MyKad must be uploaded into our system for verification purpose. Once your eKYC is approved by Health Savvy, you will receive an email allowing you to invite new family members. The invitee(s) will receive an email after you make such an invitation via “My Family” module .  The invitee(s) must go through one-off eKYC as well, by uploading MyKad or Mykid’s images for Health Savvy’s approvals. Upon approving eKYC and receiving consents from invitee(s) for sharing their medical records, Health Savvy can start linking consented invitees’ medical records with your family, so that this information is viewable via your “My Family” module. </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-secondary" @click="dismissKycPopup">Close</button>
                <button type="button" class="btn btn-primary" @click="redirectToUserProfile">Go to eKYC</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import $ from 'jquery';
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';
import identificationTypes from '@/config/identificationTypes';
import relationshipTypes from '@/config/relationshipTypes';
import {
    mask
} from 'vue-the-mask';
export default {
    'name': 'familyList',
    'directives': {
        mask
    },
    'components': {
        pagination,
        popupModal
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getfamily();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'filterName': '',
            'filterIdentityType': 0,
            'filterIdentityNumber': '',
            'kycStatus': 0,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'familyList': [],
            identificationTypes,
            relationshipTypes
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getfamily();
        this.getKycStatus();
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="tooltip"]').hover(function () {
            $('.tooltip').css('top', parseInt($('.tooltip').css('left')) + 15 + 'px'); // offset the tooltip popup to the right
        });
    },
    'methods': {
        getGuardianRequestStatus (agr, grs) {
            if (agr) {
                switch (grs) {
                case 1:
                    return 'Pending';
                case 2:
                    return 'Approved';
                case 3:
                    return 'Rejected';
                default:
                    return 'To Invite';
                }
            }
            return 'Auto-Granted';
        },
        getGuardianRequestStatusClass (agr, grs) {
            if (agr) {
                switch (grs) {
                case 1:
                    return 'badge-warning';
                case 2:
                    return 'badge-success';
                case 3:
                    return 'badge-danger';
                default:
                    return 'badge-secondary';
                }
            }
            return 'badge-primary';
        },
        getfamily () {
            this.axios.post('UserDependent/GetUserDependentList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'fn': this.filterName,
                'it': this.filterIdentityType,
                'in': this.filterIdentityNumber
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.familyList = list.map((family) => ({
                    'name': family.fn ? family.fn : '-',
                    'nric': family.in ? family.in : '-',
                    'identityType': family.it,
                    'email': family.e,
                    'relationship': family.r,
                    'userDependentId': family.udi,
                    'allowGuardianRequest': family.agr,
                    'guardianRequestStatus': family.grs
                }));
            });
        },
        getKycStatus () {
            this.axios.get('UserDependent/GetKycStatus')
                .then(({ data }) => {
                    let result = data.data;
                    this.kycStatus = result.s;
                });
        },
        addDependent () {
            if (this.kycStatus === 2) {
                this.$router.push({
                    'name': 'family-detail-add'
                });
            } else {
                this.$refs.kycPopup.show();
            }
        },
        dismissKycPopup () {
            this.$refs.kycPopup.hide();
        },
        redirectToUserProfile () {
            this.$router.push({
                'name': 'user-profile',
                'hash': 'profile-verification'
            });
            this.dismissKycPopup();
        },
        disableGuardianRequest (grs) {
            return grs === 1 || grs === 2;
        },
        guardianRequestText (grs) {
            if (grs === 1) {
                return 'Guardian Permission Pending Approval';
            } else if (grs === 2) {
                return 'Guardian Permission Approved';
            }
            return 'Request Guardian Permission';
        },
        getSearchLabel () {
            return 'Only for searching family members within same family list';
        }
    }
};

</script>

<style>

</style>
